export default __webpack_public_path__ + "static/media/Ring of Anarchy.ae526075.jpg";